export const offerfitAppGroupIdUseCases = "/offerfit/:app_group_id/use_cases";
